"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * helper.ts - part of Image Quantization Library
 */
var setImmediate = require("core-js/fn/set-immediate");
var distance = require("./distance");
var image = require("./image");
var palette = require("./palette");
function buildPaletteSync(images, _a) {
    var colorDistanceFormula = _a.colorDistanceFormula, paletteQuantization = _a.paletteQuantization, colors = _a.colors;
    var distanceCalculator = colorDistanceFormulaToColorDistance(colorDistanceFormula);
    var paletteQuantizer = paletteQuantizationToPaletteQuantizer(distanceCalculator, paletteQuantization, colors);
    images.forEach(function (image) { return paletteQuantizer.sample(image); });
    return paletteQuantizer.quantize();
}
exports.buildPaletteSync = buildPaletteSync;
function buildPalette(images, _a) {
    var colorDistanceFormula = _a.colorDistanceFormula, paletteQuantization = _a.paletteQuantization, colors = _a.colors, onProgress = _a.onProgress;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var distanceCalculator = colorDistanceFormulaToColorDistance(colorDistanceFormula);
                    var paletteQuantizer = paletteQuantizationToPaletteQuantizer(distanceCalculator, paletteQuantization, colors);
                    images.forEach(function (image) { return paletteQuantizer.sample(image); });
                    var palette;
                    var timerId;
                    var iterator = paletteQuantizer.quantizeAsync();
                    var next = function () {
                        try {
                            var result = iterator.next();
                            if (result.done) {
                                resolve(palette);
                            }
                            else {
                                if (result.value.palette)
                                    palette = result.value.palette;
                                if (onProgress)
                                    onProgress(result.value.progress);
                                timerId = setImmediate(next);
                            }
                        }
                        catch (error) {
                            clearTimeout(timerId);
                            reject(error);
                        }
                    };
                    timerId = setImmediate(next);
                })];
        });
    });
}
exports.buildPalette = buildPalette;
function applyPaletteSync(image, palette, _a) {
    var _b = _a === void 0 ? {} : _a, colorDistanceFormula = _b.colorDistanceFormula, imageQuantization = _b.imageQuantization;
    var distanceCalculator = colorDistanceFormulaToColorDistance(colorDistanceFormula);
    var imageQuantizer = imageQuantizationToImageQuantizer(distanceCalculator, imageQuantization);
    return imageQuantizer.quantize(image, palette);
}
exports.applyPaletteSync = applyPaletteSync;
function applyPalette(image, palette, _a) {
    var _b = _a === void 0 ? {} : _a, colorDistanceFormula = _b.colorDistanceFormula, imageQuantization = _b.imageQuantization, onProgress = _b.onProgress;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_c) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var distanceCalculator = colorDistanceFormulaToColorDistance(colorDistanceFormula);
                    var imageQuantizer = imageQuantizationToImageQuantizer(distanceCalculator, imageQuantization);
                    var outPointContainer;
                    var timerId;
                    var iterator = imageQuantizer.quantizeAsync(image, palette);
                    var next = function () {
                        try {
                            var result = iterator.next();
                            if (result.done) {
                                resolve(outPointContainer);
                            }
                            else {
                                if (result.value.pointContainer)
                                    outPointContainer = result.value.pointContainer;
                                if (onProgress)
                                    onProgress(result.value.progress);
                                timerId = setImmediate(next);
                            }
                        }
                        catch (error) {
                            clearTimeout(timerId);
                            reject(error);
                        }
                    };
                    timerId = setImmediate(next);
                })];
        });
    });
}
exports.applyPalette = applyPalette;
function colorDistanceFormulaToColorDistance(colorDistanceFormula) {
    if (colorDistanceFormula === void 0) { colorDistanceFormula = 'euclidean-bt709'; }
    switch (colorDistanceFormula) {
        case 'cie94-graphic-arts': return new distance.CIE94GraphicArts();
        case 'cie94-textiles': return new distance.CIE94Textiles();
        case 'ciede2000': return new distance.CIEDE2000();
        case 'color-metric': return new distance.CMetric();
        case 'euclidean': return new distance.Euclidean();
        case 'euclidean-bt709': return new distance.EuclideanBT709();
        case 'euclidean-bt709-noalpha': return new distance.EuclideanBT709NoAlpha();
        case 'manhattan': return new distance.Manhattan();
        case 'manhattan-bt709': return new distance.ManhattanBT709();
        case 'manhattan-nommyde': return new distance.ManhattanNommyde();
        case 'pngquant': return new distance.PNGQuant();
        default: throw new Error("Unknown colorDistanceFormula " + colorDistanceFormula);
    }
}
function imageQuantizationToImageQuantizer(distanceCalculator, imageQuantization) {
    if (imageQuantization === void 0) { imageQuantization = 'floyd-steinberg'; }
    switch (imageQuantization) {
        case 'nearest': return new image.NearestColor(distanceCalculator);
        case 'riemersma': return new image.ErrorDiffusionRiemersma(distanceCalculator);
        case 'floyd-steinberg': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.FloydSteinberg);
        case 'false-floyd-steinberg': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.FalseFloydSteinberg);
        case 'stucki': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.Stucki);
        case 'atkinson': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.Atkinson);
        case 'jarvis': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.Jarvis);
        case 'burkes': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.Burkes);
        case 'sierra': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.Sierra);
        case 'two-sierra': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.TwoSierra);
        case 'sierra-lite': return new image.ErrorDiffusionArray(distanceCalculator, image.ErrorDiffusionArrayKernel.SierraLite);
        default: throw new Error("Unknown imageQuantization " + imageQuantization);
    }
}
function paletteQuantizationToPaletteQuantizer(distanceCalculator, paletteQuantization, colors) {
    if (paletteQuantization === void 0) { paletteQuantization = 'wuquant'; }
    if (colors === void 0) { colors = 256; }
    switch (paletteQuantization) {
        case 'neuquant': return new palette.NeuQuant(distanceCalculator, colors);
        case 'rgbquant': return new palette.RGBQuant(distanceCalculator, colors);
        case 'wuquant': return new palette.WuQuant(distanceCalculator, colors);
        case 'neuquant-float': return new palette.NeuQuantFloat(distanceCalculator, colors);
        default: throw new Error("Unknown paletteQuantization " + paletteQuantization);
    }
}
//# sourceMappingURL=helper.js.map